import React, { useState } from "react";
import useSubmitting from "../../hooks/useSubmitting";
import companyApiService from "../../company/services/companyApiService";
import { setEncryptedTokens } from "../../utils/crypto/cryptoUtils";
import LoginShell from "./LoginShell";
import { EyeOff, EyeOpen } from "./PasswordToggleIcons";
import { inputClass, submitClass } from "./loginStyles";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, wrap] = useSubmitting();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const response = await companyApiService.login({ email, password });
      console.log(response.data.token);

      setEncryptedTokens([
        { key: "company_token", value: response.data.token },
        { key: "user", value: "company" },
      ]);
      window.location.href = "/company/dashboard";
    } catch (err) {
      setError("Failed to login. Please check your credentials.");
      console.error(err);
    }
  };

  return (
    <LoginShell
      variant="company"
      title="Company sign in"
      subtitle="Official access for company account management."
    >
      <form onSubmit={wrap(handleLogin)} className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="company-email" className="login-label">
            Email
          </label>
          <input
            id="company-email"
            name="email"
            type="email"
            placeholder="name@company.com"
            className={inputClass("company")}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            autoComplete="username"
            required
          />
        </div>
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="company-password" className="login-label">
            Password
          </label>
          <div className="relative w-full">
            <input
              id="company-password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              className={`${inputClass("company")} pr-11`}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="absolute right-2.5 top-1/2 m-0 inline-flex -translate-y-1/2 items-center justify-center border-0 bg-transparent p-1 text-[#7a8781] hover:bg-transparent hover:text-login-ink"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOff /> : <EyeOpen />}
            </button>
          </div>
        </div>
        <button
          type="submit"
          disabled={submitting}
          className={submitClass("company")}
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
        {error ? <span className="login-error">{error}</span> : null}
      </form>
    </LoginShell>
  );
};

export default Login;
